module.exports = __webpack_public_path__ + "img/29.2e11fe6e.png";